// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OnboardingCallDaten } from "../../api";
import { useGetUnauthenticatedAPI } from "../client";
import { useCallback } from "react";

export function useStarteOnboardingCall(): (
  requestBody: OnboardingCallDaten
) => Promise<void> {
  const getAPI = useGetUnauthenticatedAPI();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).calls.starteOnboardingCall({ requestBody }),
    [getAPI]
  );
}
